import { atomWithMutation } from 'jotai-tanstack-query';
import { deleteChild } from '@/api/profile/deleteChild';
import { R } from '@/Resources.resx';

export const deleteChildMutationAtom = atomWithMutation((get) => ({
    mutationFn: async (childId: string): Promise<void> => {
        return deleteChild(childId).catch((error) => {
            throw new Error(
                `${R.ErrorDeleteChild} ${error instanceof Error ? error.message : R.UnknownError}`,
            );
        });
    },
}));
